export default function DetailsPageViewLogic(props, { BASE_KEY, IfFeature }) {
    const { searchConfig, formConfig, userAccessConfig, getMessage } = props;

    function criteriaLabelProps() {
        if (searchConfig.userCanEditSearch) {
            return {
                link: {
                    onClick: searchConfig.onEdit,
                    text: getMessage(`${BASE_KEY}.edit`),
                    'data-action': 'edit-search',
                },
            };
        }

        return {};
    }

    function resultsText() {
        if (searchConfig.isRandomized) {
            return searchConfig.results.randomizedDetails.sampleFullCount.length
                ? 'random_result_details'
                : 'details_unavailable';
        }

        return 'result_details';
    }

    function resultsValues() {
        const values = {
            ...searchConfig.results,
            ...(searchConfig.results.randomizedDetails || {}),
        };

        return {
            ...values,
            total: Number(values.total || 0).toLocaleString(),
            sampled: Number(values.sampled || 0).toLocaleString(),
        };
    }

    function totalEmailsText() {
        if (
            searchConfig.isRandomized &&
      !searchConfig.results.randomizedDetails.sampleFullCount.length
        ) {
            return 'count_unavailable_total_emails';
        }

        return 'total_emails';
    }

    function formFieldPercentageInputProps() {
        const inputProps = { ...formConfig.samplePercentage };

        if (searchConfig.isRandomized || !searchConfig.userCanEditFields) {
            inputProps.status = 'disabled';
        } else if (searchConfig.results.samplePercentageErrors) {
            inputProps.status = 'error';
        }

        return inputProps;
    }

    function contentTitle() {
        if (searchConfig.isNewSearch) {
            return getMessage(`${BASE_KEY}.new_search`);
        }
        return `${getMessage(`${BASE_KEY}.details`)}:    ${searchConfig.searchName}`;
    }

    function userAccessLinkProps() {
        if (searchConfig.userCanEditFields) {
            return {
                onClick: userAccessConfig.onManageUserAccess,
                text: getMessage(`${BASE_KEY}.manage`),
                'data-action': 'manage-user-access',
            };
        }

        return {};
    }

    function totalEmails() {
        if (searchConfig.results.randomizedDetails) {
            return searchConfig.results.randomizedDetails.sampleFullCount;
        }

        return searchConfig.results.total;
    }

    function randomlySelected() {
        if (searchConfig.results.randomizedDetails) {
            return searchConfig.results.randomizedDetails.sampled;
        }

        return String(Math.ceil(searchConfig.results.total * (formConfig.samplePercentage.value / 100)),);
    }

    return {
        ...props,
        criteriaLabelProps: criteriaLabelProps(),
        resultsText: resultsText(),
        resultsValues: resultsValues(),
        totalEmailsText: totalEmailsText(),
        formFieldPercentageInputProps: formFieldPercentageInputProps(),
        contentTitle: contentTitle(),
        userAccessLinkProps: userAccessLinkProps(),
        totalEmails: totalEmails(),
        randomlySelected: randomlySelected(),
        isUserAccessEnabled: IfFeature.isEnabled('search_user_access'),
        isRandomizeSearchEnabled: IfFeature.isEnabled('randomize_results'),
    };
}
